import getConfig from 'next/config';

import {userIsLoggedIn} from '~/src/utilities/helpers/account';
import rollbar from './rollbar';

import css from '~/src/components/layout/Layout.module.scss';

const {publicRuntimeConfig: config} = getConfig();
const {pageName} = config.totm;

let adsEnabledFlag = true;
let adChannelName = 'front';

if (process.browser) {
    window.TATM = window.TATM || [];
}

const pushToTatm = (value) => {
    if (window.TATM && typeof window.TATM.push === 'function') {
        window.TATM.push(value);
    }
};

const updateTotmOnClient = (params = {}) => {
    adsEnabledFlag = typeof params.adsEnabled === 'boolean' ? params.adsEnabled : true;
    adChannelName = params.adChannel || 'front';
    params.pagetype = params.pagetype || 'overview';
    params.counter = params.counter || 0;

    if (process.browser && adsEnabledFlag) {
        const targetingObject = {
            userloggedin: userIsLoggedIn(),
            pagetype: params.pagetype,
            fresh: true,
            isWebview: params.isWebview || false
        };

        if (params.storyid) {
            targetingObject.storyid = params.storyid;
        }

        if (process.env.NODE_ENV === 'test') {
            targetingObject.adpreview = 'tamediadefault';
        }

        const totmParams = [
            pageName,
            adChannelName,
            targetingObject,
            null,
            null,
            {
                contentWrapperClass: css.content
            }
        ];

        if (window.TATM.initialized || window.TATM.length) {
            pushToTatm(() => {
                try {
                    window.TATM.updateView(...totmParams);
                } catch (error) {
                    const message = (error && error.message) || error;
                    rollbar.warning(`[TOTM] unhandled error on "updateView": ${message}`, {error});
                }
            });
        } else {
            pushToTatm(() => {
                try {
                    window.TATM.init(...totmParams);
                } catch (error) {
                    const message = (error && error.message) || error;
                    rollbar.warning(`[TOTM] unhandled error on "init": ${message}`, {error});
                }
            });
        }
    }
};

const initAdUnit = (adUnit) => {
    if (adsEnabledFlag) {
        pushToTatm(() => {
            try {
                window.TATM.initAdUnits([
                    {
                        ...adUnit,
                        adUnitName: adUnit.adUnitName
                    }
                ]);
            } catch (error) {
                const message = (error && error.message) || error;
                rollbar.warning(`[TOTM] unhandled error on "initAdUnits": ${message}`, {error});
            }
        });
    }
};

const getVastTag = async (targetingObject = {}) => {
    if (process.browser && adsEnabledFlag) {
        if (process.env.NODE_ENV === 'test') {
            targetingObject.adpreview = 'tamediadefault';
        }

        return new Promise((resolve) => {
            pushToTatm(() => {
                try {
                    window.TATM.getVast('preroll', '640x480', null, targetingObject).then(resolve);
                } catch (error) {
                    const message = (error && error.message) || error;
                    rollbar.warning(`[TOTM] unhandled error on "getVast": ${message}`, {error});
                }
            });
        });
    }
};

const pageIsReady = () => {
    if (adsEnabledFlag) {
        pushToTatm(() => {
            try {
                window.TATM.pageReady();
            } catch (error) {
                const message = (error && error.message) || error;
                rollbar.warning(`[TOTM] unhandled error on "pageReady": ${message}`, {error});
            }
        });
    }
};

export {updateTotmOnClient, initAdUnit, getVastTag, pageIsReady};
